import React, { Component } from 'react';
import Form from './Form';

class Converter extends Component {
  constructor(props) {
    super(props);

    this.convertUnit = this.convertUnit.bind(this);
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  convertUnit(data) {
    let magnitudeName = this.props.magnitude.name;

    if (this.isSameUnit(data)) return;
    if (magnitudeName === 'temperature') { return this.convertTemperature(data); }

    let result = data.valueToConvert * (data.from.factor / data.to.factor);
    data.output.value = result;
  }

  isSameUnit(data) {
    let isSameUnit = data.from.unit === data.to.unit;

    if (isSameUnit) { data.output.value = data.valueToConvert; }
    return isSameUnit;
  }

  convertTemperature(data) {
    const factors = {
      celsius: { kelvin: (value) => value + 273.15, fahrenheit: (value) => value  * 1.8 + 32 },
      fahrenheit: { celsius: (value) => (value - 32) / 1.8, kelvin: (value) => (value + 459.67) / 1.8 },
      kelvin: { celsius: (value) => value - 273.15, fahrenheit: (value) => value * 1.8 - 459.67 }
    };

    let [fromOption, toOption] = [data.fromOption, data.toOption];
    let [fromUnit, toUnit] = [fromOption.value, toOption.value];

    data.output.value = factors[fromUnit][toUnit](data.valueToConvert);
  }

  render() {
    let magnitude= this.props.magnitude;

    return(
      <section className="Converter panel">
        <h1 className="panel__title">{ this.capitalize(magnitude.name) }</h1>

        <Form magnitude={ magnitude } onFormSubmit={ this.convertUnit } />
      </section>
    );
  }
}

export default Converter;
